/**
 * ClawInstall pricing (`/pricing`) — eager half of the route. Registers the
 * file route with its SSR head only; the page component and every design /
 * seam / atom import live in `pricing.lazy.tsx` so they load with this route
 * and never land in the always-loaded `main` chunk (the `entryChunkGzipKb`
 * budget, CLA-645). Mounted outside the `/clawinstall` layout (trailing-
 * underscore escape) so the frame's `<main>` is the only main landmark.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";
import { identityFromHeadCtx, publicPageHead } from "~/lib/clawinstall-marketing-head.ts";

/** SSR head for `/pricing`: identity-scoped title/canonical, per-agent quote description. @since 1.0.0 */
export const pricingHead = (ctx?: Parameters<typeof identityFromHeadCtx>[0]) => {
  const identity = identityFromHeadCtx(ctx);
  return publicPageHead({
    path: "/pricing",
    title: `Pricing — ${identity.displayName}`,
    description:
      "Quoted per agent: one monthly rate covers the server, monitoring, updates and backups; setup is quoted for your configuration. Bring your own OpenAI key.",
    identity,
  });
};

export const Route = createFileRoute("/clawinstall_/pricing")({
  head: pricingHead,
});
